'use strict';

angular.module('core.auth', ['ngResource']);